import { RefreshCw } from 'lucide-react';

/**
 * Pull to Refresh indicator component
 * Shows spinner and pull status during refresh gesture
 */
const PullToRefreshIndicator = ({ pullDistance, isRefreshing, pullProgress }) => {
  if (pullDistance <= 0 && !isRefreshing) return null;

  const opacity = Math.min(pullProgress, 1);
  const rotation = pullProgress * 180;
  const scale = 0.5 + (pullProgress * 0.5);

  return (
    <div 
      className="fixed left-0 right-0 flex justify-center z-50 pointer-events-none transition-transform duration-200"
      style={{ 
        top: `${Math.min(pullDistance - 20, 60)}px`,
        transform: `translateY(${isRefreshing ? 0 : -20}px)`,
      }}
    >
      <div 
        className={`
          flex items-center justify-center w-10 h-10 rounded-full 
          bg-white shadow-lg border border-gray-200
          transition-all duration-200
        `}
        style={{
          opacity,
          transform: `scale(${scale})`,
        }}
      >
        <RefreshCw 
          className={`w-5 h-5 text-primary ${isRefreshing ? 'animate-spin' : ''}`}
          style={{
            transform: isRefreshing ? undefined : `rotate(${rotation}deg)`,
          }}
        />
      </div>
      
      {/* Pull hint text */}
      {!isRefreshing && pullProgress > 0.3 && pullProgress < 1 && (
        <span 
          className="absolute top-12 text-xs text-muted-foreground font-medium"
          style={{ opacity: Math.min((pullProgress - 0.3) * 2, 1) }}
        >
          Pull to refresh
        </span>
      )}
      
      {!isRefreshing && pullProgress >= 1 && (
        <span className="absolute top-12 text-xs text-primary font-semibold">
          Release to refresh
        </span>
      )}
      
      {isRefreshing && (
        <span className="absolute top-12 text-xs text-primary font-semibold">
          Refreshing...
        </span>
      )}
    </div>
  );
};

export default PullToRefreshIndicator;
